import React, { useMemo } from "react";
import "./Header.css";
// import adminAvatar from "../../../Assets/Images/AdminAvatar.png";
// import SearchIcon from "../../../Assets/Images/SearchIcon.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GetUserDetails } from "../../../Helpers/Utility";
import Avatar from "react-avatar";

export default function Header({ isCollapsed, toggleSidebar }) {
  const userDetails = useMemo(() => GetUserDetails(), []);

  return (
    <section className={`headerSection ${isCollapsed ? "collapsed" : ""}`}>
      <Container fluid>
        <Row>
          <Col></Col>
          <Col md="auto">
            {" "}
            {/* <div className="searchSection d-flex align-items-center ms-auto">
              <div className="input-group">
                <span className="input-group-text bg-transparent border-end-0 rounded-start-5">
                  <img src={SearchIcon} alt="Avatar" className="img-fluid" />
                </span>
                <input
                  type="text"
                  className="form-control searchTextBox border-start-0 rounded-end-5"
                  placeholder="Search Here..."
                />
              </div>
            </div> */}
          </Col>
          <Col xs lg="auto" className='pe-0'>
            <div className="d-flex align-items-center ms-auto justify-content-end">
              <div className="avatar">
                <Avatar
                  name={userDetails?.name}
                  size="50"
                  round={true}
                  maxInitials={2}
                  color="#16a350"
                />
              </div>
              <div className="px-3">
                <div className="avatar-name fw-semibold text-black">{userDetails?.name}</div>
                <div className="avatar-role fw-medium">Admin</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {/* <div className="d-flex position-relative">
        
          <div className="col-lg-8">
            <div className="searchSection d-flex align-items-center ms-auto">
              <div className="input-group">
                <span className="input-group-text bg-transparent border-end-0 rounded-start-5">
                  <img src={SearchIcon} alt="Avatar" className="img-fluid" />
                </span>
                <input
                  type="text"
                  className="form-control searchTextBox border-start-0 rounded-end-5"
                  placeholder="Search Here..."
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 d-flex ms-auto">
            <div className="d-flex align-items-center ms-auto">
              <img
                src={adminAvatar}
                alt="Avatar"
                className="rounded-circle avatar-image mr-2"
              />
              <div className="px-3">
                <div className="avatar-name fw-semibold">John Doe</div>
                <div className="avatar-role fw-medium">Admin</div>
              </div>
            </div>
          </div>

 
      </div> */}
    </section>
  );
}
